import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _RENDERBUFFER_FORMATS;

/* eslint-disable no-inline-comments */
import { isWebGL2 } from '../webgl-utils';
import Resource from './resource';
import assert from '../utils/assert'; // Define local GL constants to optimize minification

var GL_RENDERBUFFER = 0x8D41;
var GL_SAMPLES = 0x80A9;
var GL_RENDERBUFFER_WIDTH = 0x8D42;
var GL_RENDERBUFFER_HEIGHT = 0x8D43;
var GL_RENDERBUFFER_INTERNAL_FORMAT = 0x8D44;
var GL_RENDERBUFFER_SAMPLES = 0x8CAB; // Define local extension strings to optimize minification
// const SRGB = 'EXT_sRGB';
// const CB_FLOAT_WEBGL1 = 'WEBGL_color_buffer_float';

var CB_FLOAT_WEBGL2 = 'EXT_color_buffer_float'; // const CB_HALF_FLOAT_WEBGL1 = 'EXT_color_buffer_half_float';

export var RENDERBUFFER_FORMATS = (_RENDERBUFFER_FORMATS = {}, _defineProperty(_RENDERBUFFER_FORMATS, 33189, {}), _defineProperty(_RENDERBUFFER_FORMATS, 33190, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 36012, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 36168, {}), _defineProperty(_RENDERBUFFER_FORMATS, 34041, {}), _defineProperty(_RENDERBUFFER_FORMATS, 35056, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 36013, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 32854, {}), _defineProperty(_RENDERBUFFER_FORMATS, 36194, {}), _defineProperty(_RENDERBUFFER_FORMATS, 32855, {}), _defineProperty(_RENDERBUFFER_FORMATS, 33321, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 33330, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 33329, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 33332, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 33331, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 33334, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 33333, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 33323, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 33336, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 33335, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 33338, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 33337, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 33340, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 33339, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 32849, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 32856, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 32857, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 36220, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 36238, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 36975, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 36214, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 36232, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 36226, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 36208, {
  gl2: true
}), _defineProperty(_RENDERBUFFER_FORMATS, 33325, {
  gl2: CB_FLOAT_WEBGL2
}), _defineProperty(_RENDERBUFFER_FORMATS, 33327, {
  gl2: CB_FLOAT_WEBGL2
}), _defineProperty(_RENDERBUFFER_FORMATS, 34842, {
  gl2: CB_FLOAT_WEBGL2
}), _defineProperty(_RENDERBUFFER_FORMATS, 33326, {
  gl2: CB_FLOAT_WEBGL2
}), _defineProperty(_RENDERBUFFER_FORMATS, 33328, {
  gl2: CB_FLOAT_WEBGL2
}), _defineProperty(_RENDERBUFFER_FORMATS, 34836, {
  gl2: CB_FLOAT_WEBGL2
}), _defineProperty(_RENDERBUFFER_FORMATS, 35898, {
  gl2: CB_FLOAT_WEBGL2
}), _RENDERBUFFER_FORMATS);

function isFormatSupported(gl, format, formats) {
  var info = formats[format];

  if (!info) {
    return false;
  }

  var value = isWebGL2(gl) ? info.gl2 || info.gl1 : info.gl1;

  if (typeof value === 'string') {
    return gl.getExtension(value);
  }

  return value;
}

var Renderbuffer =
/*#__PURE__*/
function (_Resource) {
  _inherits(Renderbuffer, _Resource);

  _createClass(Renderbuffer, null, [{
    key: "isSupported",
    value: function isSupported(gl) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          format = _ref.format;

      return !format || isFormatSupported(gl, format, RENDERBUFFER_FORMATS);
    }
  }, {
    key: "getSamplesForFormat",
    value: function getSamplesForFormat(gl, _ref2) {
      var format = _ref2.format;
      // Polyfilled to return [0] under WebGL1
      return gl.getInternalformatParameter(GL_RENDERBUFFER, format, GL_SAMPLES);
    }
  }]);

  function Renderbuffer(gl) {
    var _this;

    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Renderbuffer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Renderbuffer).call(this, gl, opts));

    _this.initialize(opts);

    Object.seal(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  } // Creates and initializes a renderbuffer object's data store


  _createClass(Renderbuffer, [{
    key: "initialize",
    value: function initialize(_ref3) {
      var format = _ref3.format,
          _ref3$width = _ref3.width,
          width = _ref3$width === void 0 ? 1 : _ref3$width,
          _ref3$height = _ref3.height,
          height = _ref3$height === void 0 ? 1 : _ref3$height,
          _ref3$samples = _ref3.samples,
          samples = _ref3$samples === void 0 ? 0 : _ref3$samples;
      assert(format, 'Needs format');
      this.gl.bindRenderbuffer(GL_RENDERBUFFER, this.handle);

      if (samples !== 0 && isWebGL2(this.gl)) {
        this.gl.renderbufferStorageMultisample(GL_RENDERBUFFER, samples, format, width, height);
      } else {
        this.gl.renderbufferStorage(GL_RENDERBUFFER, format, width, height);
      } // this.gl.bindRenderbuffer(GL_RENDERBUFFER, null);


      this.format = format;
      this.width = width;
      this.height = height;
      this.samples = samples;
      return this;
    }
  }, {
    key: "resize",
    value: function resize(_ref4) {
      var width = _ref4.width,
          height = _ref4.height;

      // Don't resize if width/height haven't changed
      if (width !== this.width || height !== this.height) {
        return this.initialize({
          width: width,
          height: height,
          format: this.format,
          samples: this.samples
        });
      }

      return this;
    } // PRIVATE METHODS

  }, {
    key: "_createHandle",
    value: function _createHandle() {
      return this.gl.createRenderbuffer();
    }
  }, {
    key: "_deleteHandle",
    value: function _deleteHandle() {
      this.gl.deleteRenderbuffer(this.handle);
    }
  }, {
    key: "_bindHandle",
    value: function _bindHandle(handle) {
      this.gl.bindRenderbuffer(GL_RENDERBUFFER, handle);
    }
  }, {
    key: "_syncHandle",
    value: function _syncHandle(handle) {
      this.format = this.getParameter(GL_RENDERBUFFER_INTERNAL_FORMAT);
      this.width = this.getParameter(GL_RENDERBUFFER_WIDTH);
      this.height = this.getParameter(GL_RENDERBUFFER_HEIGHT);
      this.samples = this.getParameter(GL_RENDERBUFFER_SAMPLES);
    } // @param {Boolean} opt.autobind=true - method call will bind/unbind object
    // @returns {GLenum|GLint} - depends on pname

  }, {
    key: "_getParameter",
    value: function _getParameter(pname) {
      this.gl.bindRenderbuffer(GL_RENDERBUFFER, this.handle);
      var value = this.gl.getRenderbufferParameter(GL_RENDERBUFFER, pname); // this.gl.bindRenderbuffer(GL_RENDERBUFFER, null);

      return value;
    }
  }]);

  return Renderbuffer;
}(Resource);

export { Renderbuffer as default };
//# sourceMappingURL=renderbuffer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist/esm/webgl/renderbuffer.js
// module id = 230
// module chunks = 0